import { Button, Tooltip } from '@chakra-ui/react';
import { useResource } from 'datx-jsonapi-react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import CodeIcon from '@/assets/icons/code-icon.svg';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { useLecturePlayerContext } from '@/components/ui/features/lecture/LecturePlayer/LecturePlayer.context';
import { queryThinLectureWithTagAndEvent } from '@/fetchers/thinLectures';
import { queryLectureAccessPermission } from '@/queries/lecture-access-permissions';

export const EmbedButton = () => {
  const { t } = useTranslation();
  const { id: lectureId } = useLecturePageQueryParams();
  const { data: lecture } = useResource(queryThinLectureWithTagAndEvent(lectureId));
  const { data } = useResource(queryLectureAccessPermission(lectureId));
  const [player] = useLecturePlayerContext();
  const router = useRouter();

  const isDisabled = data?.restricted;

  function handleEmbedClick() {
    const time = Math.round(player?.currentTime());
    const href = `/lecture/embed/${lectureId}-${lecture.slug}?t=${time}`;

    router.push(href);
  }

  return (
    <Tooltip
      isDisabled={!isDisabled}
      label={t('lectureEmbed.embedTooltip')}
      bg="white"
      borderRadius="2px"
      hasArrow
      maxW="280px"
      p={4}
    >
      <Button
        isDisabled={isDisabled}
        _disabled={{ color: 'gray.500' }}
        type="button"
        variant="ghost"
        colorScheme="white"
        onClick={handleEmbedClick}
        pl={0}
      >
        {t('newLecture.embed')}
        <CodeIcon css={{ color: isDisabled ? 'gray.500' : 'white' }} />
      </Button>
    </Tooltip>
  );
};
